<template>
  <div id="app">
    <v-snackbar v-model="snackbar">
      {{ msg }}
      <v-btn dark text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-row class="justify-center">
      <v-dialog v-model="dialog" persistent max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" height="60px" text small depressed light v-on="on">Clique aqui</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t("pageSenha.title") }}</span>
          </v-card-title>
          <v-card-text v-if="!loading && !success">
            <v-container>
              <v-row>
                <v-col class="col-12">
                  <v-text-field
                    solo
                    flat
                    label="Email"
                    v-model="email"
                    required
                    background-color="#F7F7F7"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions v-if="!loading && !success">
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">Fechar</v-btn>
            <v-btn color="secondary" outlined @click="forgotPassword">Enviar</v-btn>
          </v-card-actions>

          <v-card-text v-if="loading">
            <div class="text-center">
              <v-progress-circular :width="3" color="secondary" indeterminate></v-progress-circular>
            </div>
          </v-card-text>

          <v-card-text v-if="!loading && success">
            <v-container>
              <v-row class="col-12 justify-center">
                <p text-lg-center>{{ msg }}</p>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions v-if="!loading && success">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialog = false">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import Api from '../services/httpClient';

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      success: false,
      email: '',
      msg: '',
      snackbar: false,
    };
  },

  methods: {
      forgotPassword: function(){
        this.loading = true
        Api.post('/users/forgot_password/', {
            username: this.email,
        })
        .then(res => {
          this.msg = res.data;
          this.success = true;
        })
        .finally(() => {
          this.loading = false;
        }).catch(e=>{
          this.snackbar = true;
          this.msg = e.response.data.detail;
        });
    },
  },
};
</script>
<style scoped>
#app {
  overflow: hidden;
}

</style>
